import * as htmlToImage from 'html-to-image';
import downloadjs from "downloadjs";

export const HTML2Image = () => {

	const filter = (node) => {
		const exclusionClasses = ['noscript'];
		const exclusionIds = ['tag-manager'];

		return !(
			exclusionClasses.some((classname) => node.classList?.contains(classname)) ||
			exclusionIds.some((id) => node.outerHTML?.includes(id))
		);
	}

	const node = document.body;
		htmlToImage.toPng(node, { filter: filter }).then((dataUrl) => {
			downloadjs(dataUrl, 'pl-ferrari-screenshot.png');
  		}).catch((err) => {
    		console.error('Something went wrong with HTMLtoImage', err);
  	});
}